import React from "react";
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardIcon from "@mui/icons-material/Keyboard";

const SHORTCUT_ITEMS = [
  { keys: ["←", "→"], labelZh: "上一章 / 下一章（无经文选中时）", labelEn: "Previous / Next chapter" },
  { keys: ["M"], labelZh: "打开 / 关闭圣经目录", labelEn: "Toggle catalog drawer" },
  { keys: ["S"], labelZh: "打开 / 关闭快捷阅读设置", labelEn: "Toggle quick settings" },
  { keys: ["B"], labelZh: "打开 / 关闭书签面板", labelEn: "Toggle bookmarks" },
  { keys: ["Z"], labelZh: "进入 / 退出专注阅读模式", labelEn: "Toggle focus mode" },
  { keys: ["F"], labelZh: "进入 / 退出全屏阅读", labelEn: "Toggle fullscreen" },
  { keys: ["⌘/Ctrl", "C"], labelZh: "复制已选中的经文（含出处）", labelEn: "Copy selected verses" },
  { keys: ["Esc"], labelZh: "取消经文选中 / 退出专注或全屏", labelEn: "Clear selection / Exit mode" },
  { keys: ["?"], labelZh: "查看键盘快捷键帮助", labelEn: "Show keyboard shortcuts" },
];

const ShortcutsHelpDialog = ({ open, onClose, edition }) => {
  const isEn = edition?.id === "en";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <KeyboardIcon color="primary" fontSize="small" />
          <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
            {isEn ? "Keyboard Shortcuts" : "阅读器键盘快捷键"}
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose} aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
          {SHORTCUT_ITEMS.map((item, idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Typography variant="body2" color="text.primary">
                {isEn ? item.labelEn : item.labelZh}
              </Typography>
              <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                {item.keys.map((k) => (
                  <Chip
                    key={k}
                    label={k}
                    size="small"
                    variant="outlined"
                    sx={{
                      height: 22,
                      fontWeight: 700,
                      fontSize: "0.72rem",
                      fontFamily: "monospace",
                    }}
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ShortcutsHelpDialog;
